import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import '../css/GaleriaDeAppsItem.css';

class GaleriaDeAppsItem extends Component {

    urlWhithLang(appId, lang){
        if(lang)
            return `/app/${lang}/${appId}`;
        else
            return `/app/${appId}`;
    }    

  render() {
    const app = this.props.app.Contents[0];  
    
    return (
        <Link to={this.urlWhithLang(app.locationId, app.lang)} className="galeriaDeApps-itens">
            {/*<section className="galeriaDeApps-itens">*/}
                
                    <div className="galeriaDeApps-itens-img">
                        <img src={this.props.app.icon} alt={app.name} />
                    </div>
                    <div className="galeriaDeApps-itens-info">
                        <div className="galeriaDeApps-itens-info-margin">
                            <h2>{app.name}</h2>
                            <p className="galeriaDeApps-itens-info-shortDescription">
                                {app.shortDescription}
                            </p>
                            <p className="galeriaDeApps-itens-info-button">
                                <span>Mais Informações</span>
                            </p>
                        </div>
                    </div>
                
             {/*</section>*/}
        </Link>    
    );
  }
}

export default GaleriaDeAppsItem;



// WEBPACK FOOTER //
// ./src/componentes/GaleriaDeAppsItem.js